import React, { useEffect, useState } from 'react'
import Navbar from '../pages/Navbar';
import Footer from '../pages/Footer';
import axios from 'axios';
import $ from "jquery";

const AllFaq = () => {
          const [background, setBackground] = useState("");
                            
                              useEffect(() => {
                                const backgroundUrl = "/assets/pic/breadcrumb-bg.jpg";
                                setBackground(backgroundUrl);
                              }, []);
                              const [background1, setBackground1] = useState("");
                            
                              useEffect(() => {
                                const backgroundUrl1 = "https://html.xpressbuddy.com/e.visa/assets/img/bg/b_bg.jpg";
                                setBackground1(backgroundUrl1);
                              }, []);
                                  const [background12, setBackground12] = useState("");
                                    
                                      useEffect(() => {
                                        const backgroundUrl12 = "assets/img/bg/blog_bg.png";
                                        setBackground12(backgroundUrl12);
                                      }, []);



                                        const [faqData, setFaqData] = useState([]);
                                      
                                        useEffect(() => {
                                          axios
                                            .get("https://goforen.com/go_foren/get_faq_data/")
                                            .then((response) => setFaqData(response.data))
                                            .catch((error) => console.error("Error fetching FAQ data:", error));
                                        }, []);
                                      
                                          const [galleryData, setGalleryData] = useState([])
                                        
                                          useEffect(() => {
                                            axios.get('https://goforen.com/go_foren/get_gallery_data/')
                                              .then((res) => {
                                                setGalleryData(res.data)
                                              })
                                              .catch((err) => {
                                                console.error('Failed to fetch gallery data:', err)
                                              })
                                          }, [])
                                            //   FAQ start
                                            useEffect(() => {
                                              // Accordion Box functionality (mimicking your jQuery code)
                                              if ($(".accordion_box").length) {
                                                $(".accordion_box").on("click", ".acc-btn", function () {
                                                  const outerBox = $(this).parents(".accordion_box");
                                                  const target = $(this).parents(".accordion");
                                          
                                                  if ($(this).next(".acc_body").is(":visible")) {
                                                    $(this).removeClass("active");
                                                    $(this).next(".acc_body").slideUp(300);
                                                    $(outerBox).children(".accordion").removeClass("active-block");
                                                  } else {
                                                    $(outerBox).find(".accordion .acc-btn").removeClass("active");
                                                    $(this).addClass("active");
                                                    $(outerBox).children(".accordion").removeClass("active-block");
                                                    $(outerBox).find(".accordion").children(".acc_body").slideUp(300);
                                                    target.addClass("active-block");
                                                    $(this).next(".acc_body").slideDown(300);
                                                  }
                                                });
                                              }
                                          
                                              // Cleanup the event listener on component unmount
                                              return () => {
                                                $(".accordion_box").off("click", ".acc-btn");
                                              };
                                            }, []);
                                            //FAQ end
                                          
  return (
    <>
      <div>
        <Navbar />
         <section
  className="breadcrumb pos-rel bg_img"
  style={{ 
    backgroundImage: `url(${background})`, 
    minHeight: '400px',
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }}
>
  {/* Overlay */}
  <div style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // black overlay with 50% opacity
    zIndex: 1
  }}></div>

  <div className="container" style={{ position: 'relative', zIndex: 2 }}>
    <div className="breadcrumb__content">
    <h2 className="breadcrumb__title" style={{color:'#fff'}}>FAQ</h2>
            <ul className="breadcrumb__list clearfix">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li className="breadcrumb-item">FAQ</li>
            </ul>
    </div>
  </div>
      
    
    
      </section>

       <section className="faq pt-120 pb-120">
      <div className="container">
        <div className="row">
         

          <div className="col-lg-12">
            <div className="xb-faq">
              <ul className="accordion_box clearfix">
                {faqData.map((item, index) => (
                  <li
                    key={item.id}
                    className={`accordion block ${
                      index === 0 ? "active-block" : ""
                    }`}
                  >
                    <div className="acc-btn">
                      {item.question}
                      <span className="arrow"></span>
                    </div>
                    <div className={`acc_body ${index === 0 ? "current" : ""}`}>
                      <div
                        className="content"
                        dangerouslySetInnerHTML={{ __html: item.answer }}
                      />
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          
        </div>
        </div>
        </section>
        <Footer />
      </div>
    </>
  )
}

export default AllFaq
